import {observer} from 'mobx-react';
import {AlertModal, ModalButtons} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const ShareWithRevieweeModal = observer(({reviewee, isOpen, onClose, onSubmit}) => {
  return (
    <AlertModal
      isOpen={isOpen}
      onHide={onClose}
      size='md'
      header='performance_reviews.view.Share'
    >
      <div className='space-y-2'>
        <FormattedMessage
          id='performance_reviews.view.END_REVIEWEE_DESCRIPTION_1'
          values={{revieweeName: _.get(reviewee, 'employee.name')}}
        />
        {!reviewee.canViewAllReviews && <div>
          <FormattedMessage
            id='performance_reviews.view.END_REVIEWEE_DESCRIPTION_2'
            values={{revieweeName: _.get(reviewee, 'employee.name')}}
          />
        </div>}
      </div>
      <ModalButtons
        saveCaption='performance_reviews.view.Share'
        onSave={() => onSubmit()}
        onCancel={onClose}
      />
    </AlertModal>
  );
});

export default ShareWithRevieweeModal;
